module.exports = __webpack_public_path__ + "static/media/diplomMaster.942deeda.jpg";